import { render, staticRenderFns } from "./CabinConfigBirthday.vue?vue&type=template&id=b7a78108&scoped=true"
import script from "./CabinConfigBirthday.vue?vue&type=script&lang=js"
export * from "./CabinConfigBirthday.vue?vue&type=script&lang=js"
import style0 from "./CabinConfigBirthday.vue?vue&type=style&index=0&id=b7a78108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a78108",
  null
  
)

export default component.exports